/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridColumnSpacer = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnSpacer, _super);
    function GridColumnSpacer() {
        var _this = _super.call(this) || this;
        _this.g = 0;
        _this.h = 0;
        _this.m = 0;
        _this.c = false;
        _this.l = 0;
        _this.b = false;
        _this.a = false;
        _this.m = GridColumnSpacer.k;
        GridColumnSpacer.k++;
        return _this;
    }
    Object.defineProperty(GridColumnSpacer.prototype, "i", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            this.g = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "j", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.h = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "o", {
        get: function () {
            return this.m;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "f", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "n", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "e", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            this.b = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnSpacer.prototype, "d", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            this.a = a;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnSpacer.$t = markType(GridColumnSpacer, 'GridColumnSpacer');
    GridColumnSpacer.k = 0;
    return GridColumnSpacer;
}(Base));
export { GridColumnSpacer };
//# sourceMappingURL=GridColumnSpacer.js.map
